export default {
  有效交易量达标即可获得:`Chỉ cần đạt khối lượng giao dịch hợp lệ là có thể nhận được phần thưởng, chi tiết xem trong mục <a href="#pay-session5">lưu ý hoạt động.</a>`,
  交易领薪计划: "Chương trình Phát triển Quản lý Quỹ",
  为了鼓励交易者提升交易水平:`Phát triển lượng người theo dõi để nhận tới <span class="red">18<span class="sRed">%</span></span> mỗi năm`,
  加入交易社区: "Thưởng hàng tháng được trao dựa trên số vốn mà nhà giao dịch quản lý, với mức thưởng có thể lên tới 18% mỗi năm.",
  即刻发起交易信号: "Cung cấp tín hiệu ngay",
  无限奖励月月拿: "Phần thưởng không giới hạn hàng tháng",
  优享11个专属大礼: "Nhận 11phần quà ưu đãi đặc biệt",
  即刻加入: "THAM GIA NGAY",
  交易员等级奖励机制: `Cơ chế thưởng theo cấp độ nhà giao dịch`,
  EBC基于跟随人数和资金提供五档奖励:
    "EBC cung cấp 5 cấp độ thưởng dựa trên số lượng người theo dõi và số tiền quỹ, không giới hạn số lượng vị thế giao dịch, chỉ dựa vào mức độ nổi tiếng trong ngành.",
  "/月": "/tháng",
  精英交易员: "Trader mới nổi",
  // 管理资金量: "Quản lý quỹ",
  // 跟随账户数: "Số lượng người theo dõi",
  管理资金量: "AUM",
  跟随账户数: "Followers",
  大师交易员: "Trader ưu tú",
  冠军交易员: "Trader vô địch",
  明星交易员: "Trader ngôi sao",
  资金管理费: "1% Quản lý quỹ mỗi năm",
  传奇交易员: "Trader huyền thoại",
  多层次的增值服务: "Lợi ích giá trị gia tăng",
  EBC提供多达11项增值服务:
    "EBC cung cấp tới 11 lợi ích giá trị gia tăng, tích hợp lưu lượng và tài nguyên truyền thông để tăng cường ảnh hưởng của tín hiệu.",
  "精英/大师交易员": "Mới nổi/Ưu tú",

  "7×24小时优先客服": "Phục vụ 24*7",
  金融投资经典书籍礼遇: "Sách Đầu Tư Miễn Phí",
  专属VPS赞助: "Tài trợ VPS Độc Quyền",
  订单流软件1年使用权: "Quyền sử dụng Order Flow 1 năm",
  EBC定制大礼包: "Gói Quà Tặng EBC Đặc Biệt",
  信号优先置顶展示: "Hiển Thị Tín Hiệu Hàng Đầu",
  受邀参观海外办公室: "Tham quan văn phòng tại nước ngoài",
  巴萨球星联名礼包: "Bộ Quà Tặng Cầu Thủ Ngôi Sao FC Barcelona",
  巴萨赛场传奇之旅: "Trải Nghiệm Sân Vận Động Barcelona Huyền Thoại",
  品牌战略合作: "Hợp Tác Thương Hiệu Chiến Lược",
  全球金融资源管家服务: "Dịch Vụ Quản Lý Tài Nguyên Tài Chính Toàn Cầu",
  五维指标评价系统: "Hệ thống đánh giá năm chiều",
  为交易员信号提供公开透明的评估:
    "Cung cấp đánh giá minh bạch và công khai cho tín hiệu giao dịch của các trader, giúp thể hiện rõ phong cách giao dịch và tăng độ nổi tiếng, thu hút nhiều người theo dõi hơn nữa.",
  收益率: "Tỉ lệ lợi nhuận",
  历史收益率: "Tỷ lệ lợi nhuận lịch sử, càng cao càng tốt.",
  最大回撤: "Mức rút tối đa",
  衡量风控能力: "Đánh giá khả năng quản lý rủi ro, càng thấp thì càng an toàn.",
  获利系数: "Hệ số lợi nhuận",
  利润因子: "Hệ số lợi nhuận, càng cao khả năng sinh lời càng mạnh.",
  夏普比率: "Tỷ lệ Sharpe",
  每份风险的收益: "Lợi nhuận trên mỗi đơn vị rủi ro, càng cao thì càng tốt.",
  标准差: "Độ lệch chuẩn",
  收益波动率: "Biến động lợi nhuận, càng thấp càng ổn định.",
  以上数据仅供参考: "*Dữ liệu trên chỉ mang tính tham khảo.",
  活动须知: "Những điều cần biết:",
  list: [
    {
      label: "1. Định nghĩa thông tin sao chép giao dịch",
      value: [
        {label:'Số tiền sao chép giao dịch: Số tiền sao chép giao dịch của một tài khoản = Số dư tài khoản ÷ Số tín hiệu giao dịch đang theo dõi.',value:[]},
        {label:'Giới hạn sao chép: Mỗi tài khoản được theo dõi tối đa 10 tín hiệu giao dịch cùng lúc.',value:[]},
        {label:'Tài khoản người theo dõi hợp lệ: Một tài khoản được coi là hợp lệ nếu vốn người theo dõi ít nhất là $500. Những tài khoản có dưới $500 sẽ không được tính là tài khoản người theo dõi hợp lệ và sẽ không được cộng vào tổng vốn người theo dõi.​',value:[]},
        {label:'Người dùng sao chép hợp lệ: Dưới cùng một tài khoản EBC, nếu nhiều tài khoản hợp lệ cùng sao chép một nhà giao dịch (tín hiệu), chỉ được tính là 1 người dùng hợp lệ.',value:[]},
        {label:'Tổng số tiền quản lý: Tổng số tiền sao chép + Số dư tài khoản của nhà giao dịch (tín hiệu).',value:[]},
        // {label:'Loại trừ dữ liệu: Tài khoản của nhà giao dịch tự sao chép tín hiệu của chính mình sẽ không được tính vào người dùng hợp lệ và tổng số tiền sao chép.',value:[]}
      ],
    },
    {
      label: "2. Quy tắc kích hoạt cấp bậc và nhận thưởng",
      value: [
        {label:'Kích hoạt cấp bậc:',value:['Hệ thống tự động đánh giá mỗi giờ. Nếu đồng thời đạt yêu cầu về tổng số tiền quản lý và số lượng người dùng hợp lệ của một cấp độ nào đó, cấp độ đó sẽ được coi là đã kích hoạt.']},
        {label:'Điều kiện nhận thưởng (cần đồng thời đáp ứng):',value:['Mỗi ngày tự nhiên trong tháng hiện tại đều phải đạt cấp độ giao dịch tương ứng.',{innerLabel:'Khối lượng giao dịch hiệu quả (lot) ≥ Số dư trung bình hàng ngày của Nhà giao dịch (Tài khoản cung cấp) × 0,2%:',innerValue:['Khối lượng giao dịch hợp lệ = Khối lượng giao dịch đã đóng trong tháng + Vị thế ròng (sau khi trừ đi vị thế hai chiều cùng mã giao dịch).','Số dư trung bình ngày của nhà giao dịch (tín hiệu) = Tổng số dư hàng ngày trong tháng ÷ Số ngày tự nhiên trong tháng.','Giao dịch chứng khoán Mỹ và ETF không được tính vào khối lượng giao dịch hợp lệ.']}]},
        {label:'Cách tính và trao thưởng:',value:['Tổng số tiền quản lý trung bình ngày = Tổng tiền quản lý mỗi ngày trong tháng ÷ Số ngày tự nhiên trong tháng.','Thưởng tháng = (Tổng tiền quản lý trung bình ngày × Tỷ lệ phí quản lý vốn) ÷ 12.','Thưởng sẽ được tính toán trong tuần đầu tiên của tháng sau, sau khi phê duyệt sẽ chuyển vào tài khoản giao dịch.','Chỉ những tài khoản khách hàng thực và hợp lệ mới có thể tham gia hoạt động này, quyền giải thích cuối cùng về quy tắc hoạt động và định nghĩa những  tài khoản khách hàng hợp lệ thuộc về EBC.']}
      ],
    }
  ],
  年化资金管理费: "Phí quản lý quỹ hàng năm",
};
